// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1imWd","left":"InfoRow_left__3PS9C"};